






















































































































































import { Component, Vue, Ref } from 'vue-property-decorator'
import { VueCsvImport } from 'vue-csv-import'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindClienteUseCase, FindImportacaoUseCase } from '@/usecases'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { removerFormatacaoDeCnpjOuCpf } from '@/shareds/formatadores'
import Confirmacao from '@/components/ui/Confirmacao.vue'

@Component({
	components: {
		VueCsvImport,
		Confirmacao,
	},
})
export default class DialogoDeCsvDeAlteracaoEmMassaDeClientes extends Vue {
	@Ref() csvComponent!: VueCsvImport
	@Ref('confirmaAlteracoes') confirmaAlteracoes!: Confirmacao

	findImportacaoUseCase = new FindImportacaoUseCase()
	findClienteUseCase = new FindClienteUseCase()

	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
	];
	csv: any[] | null = null
	tipoLayout: string | null = null
	loading = false
	hasHeaders = true
	inputFile: HTMLInputElement | null = null
	hover= false
	removerFormatacaoDeCnpjOuCpf = removerFormatacaoDeCnpjOuCpf
	lojaId: string | null = null
	tituloConfirmacao = 'Deseja prosseguir mesmo assim?'
	subtituloConfirmacao = ''
	private confirmacaoResolver: ((v: boolean) => void) | null = null
	csvKey = 0

	camposCsvDeAlteracaoEmMassa = {
		cpfOuCnpj: 'cpf_ou_cnpj',
	}

	get arquivoSelecionado() {
		if((this.csvComponent && this.csvComponent.fileSelected) || (this.inputFile && this.inputFile.value)){
			return "Arquivo selecionado, favor definir colunas"
		}
		return "Nenhum arquivo selecionado"
	}

	async mostrar(lojaId: string) {
		if (!lojaId) AlertModule.setError("Selecione uma loja antes de importar o CSV.")
		this.lojaId = lojaId
		this.resetarImportacao()
		this.mostra = true
	}

	cancelar() {
		this.mostra = false
		this.resetarImportacao()
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	async concluirImportacao() {
		if (!this.lojaId) return AlertModule.setError("Selecione uma loja antes de importar o CSV.")

		this.loading = true

		try {
			if (!this.csv || !Array.isArray(this.csv)) {
				throw new Error('CSV não carregado. Favor selecionar o arquivo e definir colunas.')
			}

			const documentos = (this.csv ?? [])
				.map((row: any) => removerFormatacaoDeCnpjOuCpf(String(row?.cpfOuCnpj ?? row?.cpf_ou_cnpj ?? '')))
				.filter((d: string | null): d is string => !!d)

			const unicos = Array.from(new Set(documentos))

			if (!unicos.length) {
				throw new Error('Nenhum CPF/CNPJ válido encontrado no CSV.')
			}

			const clientesEncontrados = await this.findClienteUseCase.findClientesIdsDoCsvDeAlteracaoEmMassa(this.lojaId, unicos)

			if (clientesEncontrados.length === 0  || !clientesEncontrados) return AlertModule.setError("Nenhum cadastro de cliente encontrado para essa loja.")

			const encontradosSet = new Set((clientesEncontrados ?? []).map((c: any) => removerFormatacaoDeCnpjOuCpf(String(c.cnpjOuCpf ?? ''))))
			const faltantes = unicos.filter(doc => !encontradosSet.has(doc))

			if (faltantes.length) {
				const prosseguir = await this.abrirConfirmacaoFaltantes(faltantes)
				if (!prosseguir) return
			}

			this.$emit('selecionarClientesPorIds', clientesEncontrados)

			this.cancelar()
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.loading = false
		}
	}


	async baixarModelo() {
		const rows = [
			[
				'cpf_ou_cnpj',
			],
			[
				'78224989089',
			],
			[
				'609.904.030-76',
			],
		]

		const csvContent = "data:text/csv;charset=utf-8," 
			+ rows.map(e => e.join(";")).join("\n")

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement("a")
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", "modelo_importacao_clientes_em_massa.csv")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	clickCsv() {
		this.inputFile = document.querySelector('.form-control-file') as HTMLInputElement | null

		if (this.inputFile) {
			this.inputFile.value = ''

			this.inputFile.click()
		}
		
	}

	private abrirConfirmacaoFaltantes(faltantes: string[]): Promise<boolean> {
		const preview = faltantes.slice(0, 20).join(', ')
		const sufixo = faltantes.length > 20 ? ` e mais ${faltantes.length - 20}...` : ''

		this.tituloConfirmacao = 'Deseja prosseguir mesmo assim?'
		this.subtituloConfirmacao =
      `CSV contém ${faltantes.length} documentos não cadastrados como clientes: ${preview}${sufixo}. `

		return new Promise<boolean>((resolve) => {
			this.confirmacaoResolver = resolve;

			(this.confirmaAlteracoes as any).mostrar()
		})
	}

	onConfirmarConfirmacao() {
		this.confirmacaoResolver?.(true)
		this.confirmacaoResolver = null
	}

	onNegarConfirmacao() {
		this.confirmacaoResolver?.(false)
		this.confirmacaoResolver = null
	}

	resetarImportacao() {
		this.csv = null
		this.hasHeaders = true
		this.inputFile = null

		this.csvKey++

		if (this.csvComponent) {
			this.csvComponent.sample = null
			this.csvComponent.fileSelected = false
			this.csvComponent.map = []
		}
	}

}
